import {getField, updateField} from 'vuex-map-fields';

const state = {
    vehiculo: {
        info_vehiculo: {
            id_reporte: "",
            cliente: {
                nombre: "",
                celular: "",
                email: ""
            },
            asesor: {
                nombre: "",
                celular: "",
                email: ""
            },
            vehiculo: {
                precio_venta: 0
            },
            estado_principal: ""
        },
        documentos: {},
        fotos: [],
        tabs: {
            ficha_tecnica: {},
            accesorios: {},
            inspeccion: {}
        },
        vr_retoma: 0
    },
    vehiculoSimilares: [],
    comentario: {
        nombre: null,
        email: null,
        comentario: null
    },
    comentarios: [],
    video_link:null,
    fotos_modal:null
}

const getters = {
    getField 
}

const mutations = {
    updateField,
    addComment(state, payload) {
        state.comentarios.push(payload);
    },
    updateComments(state, payload) {
        state.comentarios = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
